import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Card, CardBody, Col, Row } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor"
import { useDispatch } from "react-redux"
import classNames from "classnames"
import { getCampusVirtualResumenPuntualidad } from "store/actions"
import {
  useCampusVirtualResumenPuntualidad,
  useCampusVirtualIdCampus,
  useCampusVirtualNombreCampusSeleccionado,
} from "store/selectors"
// import { colors } from "react-select/dist/declarations/src/theme"
import DatosGenerales from "components/Common/DatosGenerales"

const Puntualidad = ({ dataColors }) => {
  const apexCardUserChartColors = getChartColorsArray(dataColors)
  const dataResumenPuntualidad = useCampusVirtualResumenPuntualidad()
  const idCampus = useCampusVirtualIdCampus()
  const nombreCampusActual = useCampusVirtualNombreCampusSeleccionado()

  const dispatch = useDispatch()

  const [series, setSeries] = useState([])

  const [categoriasPuntualidad, setCategoriasPuntualidad] = useState([""])
  const [mesesData, setMesesData] = useState(-12)

  const optionsInit = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    colors: apexCardUserChartColors,

    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    xaxis: {
      categories: categoriasPuntualidad || [],
    },
    markers: {
      size: 3,
      strokeWidth: 3,

      hover: {
        size: 4,
        sizeOffset: 2,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
    },
  }
  const [options, setOptions] = useState(optionsInit)

  // Ejecutar solo cuando idCampus cambie
  useEffect(() => {
    if (idCampus > 0) {
      dispatch(
        getCampusVirtualResumenPuntualidad({
          nombreSolicitud: "getresumenpuntualidad",
          idCampus: idCampus,
          mes: mesesData,
          ano: 2025,
        })
      )
    }
  }, [dispatch, idCampus, mesesData])

  useEffect(() => {
    if (dataResumenPuntualidad && dataResumenPuntualidad.length > 0) {
      // Ordenar los datos por año y mes
      dataResumenPuntualidad.sort((a, b) => a.Anio - b.Anio || a.Mes - b.Mes)

      // Crear arrays para las series
      let categories = dataResumenPuntualidad.map(
        item => `${item.Mes}-${item.Anio}`
      )
      let totalAlumnos = dataResumenPuntualidad.map(item => item.Total_Alumnos)
      let alumnosPuntuales = dataResumenPuntualidad.map(
        item => item.Alumnos_Pagos_Puntuales
      )
      let porcentajePuntuales = dataResumenPuntualidad.map(
        item => item.Porcentaje_Pagos_Puntuales
      )

      console.log("porcentajePuntuales:", porcentajePuntuales)

      setCategoriasPuntualidad(categories)

      setSeries([
        {
          name: "Total Alumnos",
          data: totalAlumnos,
        },
        {
          name: "Puntuales",
          data: alumnosPuntuales,
        },
      ])

      setOptions(prevOptions => ({
        ...prevOptions,
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            // Val es el número base (ej. 43)
            // serie 1 es la de Puntuales
            if (opts.seriesIndex === 1) {
              // Muestra la etiqueta en % (ej. 19.0%)
              const pct = porcentajePuntuales[opts.dataPointIndex] || 0
              return `${pct.toFixed(1)}%`
            }
            // Si es la serie 0 (Total Alumnos), muestra el valor numérico
            return val
          },
          style: {
            fontSize: "12px",
            fontWeight: "bold",
            colors: ["#333"],
          },
          offsetY: -5,
        },
        xaxis: {
          categories: categories || [],
        },
      }))
    }
  }, [dataResumenPuntualidad])

  useEffect(() => {
    console.log(categoriasPuntualidad)
  }, [categoriasPuntualidad])

  return (
    <React.Fragment>
      <Col xl={8}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">
                Puntualidad {nombreCampusActual}
              </h5>
              <div className="ms-auto">
                <div className="toolbar d-flex flex-wrap gap-2 text-end">
                  <button
                    type="button"
                    className={classNames("btn btn-light btn-sm", {
                      active: mesesData === -60,
                    })}
                    onClick={() => setMesesData(-60)}
                  >
                    Todo
                  </button>{" "}
                  <button
                    type="button"
                    className={classNames("btn btn-light btn-sm", {
                      active: mesesData === -2,
                    })}
                    onClick={() => setMesesData(-2)}
                  >
                    1M
                  </button>{" "}
                  <button
                    type="button"
                    className={classNames("btn btn-light btn-sm", {
                      active: mesesData === -6,
                    })}
                    onClick={() => setMesesData(-6)}
                  >
                    6M
                  </button>{" "}
                  <button
                    type="button"
                    className={classNames("btn btn-light btn-sm", {
                      active: mesesData === -12,
                    })}
                    onClick={() => setMesesData(-12)}
                  >
                    1A
                  </button>{" "}
                  <button
                    type="button"
                    className={classNames("btn btn-light btn-sm", {
                      active: mesesData === -24,
                    })}
                    onClick={() => setMesesData(-24)}
                  >
                    2A
                  </button>{" "}
                </div>
              </div>
            </div>

            <hr className="mb-4" />
            <div id="area-chart" dir="ltr">
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={350}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

Puntualidad.propTypes = {
  options: PropTypes.any,
  series: PropTypes.any,
}

export default Puntualidad
